import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaWhatsapp,
  FaDirections,
  FaArrowRight,
} from "react-icons/fa";
import "./Location.css";

const Location = () => {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  return (
    <section className="rk-location-section">
      <div className="rk-location-container">
        {/* =========================
            SECTION HEADER
        ========================== */}
        <div className="rk-location-header">
          <div className="rk-location-eyebrow">
            <span></span>
            VISIT OUR WORKSHOP
            <span></span>
          </div>

          <h2>
            Find Us <em>in Noida</em>
          </h2>

          <p>
            Visit RK Sofa Works for professional sofa repair, upholstery,
            fabric change and furniture restoration services across Noida.
          </p>
        </div>

        {/* =========================
            LOCATION CARD
        ========================== */}
        <div className="rk-location-card">
          {/* =========================
              LEFT INFORMATION
          ========================== */}
          <div className="rk-location-info">
            <div className="rk-location-info-bg"></div>

            <div className="rk-location-info-content">
              {/* Top */}
              <div className="rk-location-brand">
                <div className="rk-location-main-icon">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <span>RK SOFA WORKS</span>
                  <h3>Our Workshop</h3>
                </div>
              </div>

              {/* Address */}
              <div className="rk-location-detail">
                <div className="rk-location-detail-icon">
                  <FaMapMarkerAlt />
                </div>

                <div className="rk-location-detail-content">
                  <span>WORKSHOP ADDRESS</span>

                  <p>
                    Pillar 104, Bhangel, Sector 102,
                    <br />
                    Noida, Uttar Pradesh 201304
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="rk-location-detail">
                <div className="rk-location-detail-icon">
                  <FaPhone />
                </div>

                <div className="rk-location-detail-content">
                  <span>CALL US</span>

                  <a href={`tel:${PHONE}`}>
                    +91 93183 33680
                  </a>
                </div>
              </div>

              {/* Service Area */}
              <div className="rk-location-detail">
                <div className="rk-location-detail-icon">
                  <FaDirections />
                </div>

                <div className="rk-location-detail-content">
                  <span>SERVICE AREA</span>

                  <p>All areas across Noida</p>
                </div>
              </div>

              {/* Buttons */}
              <div className="rk-location-actions">
                <a
                  href={`tel:${PHONE}`}
                  className="rk-location-call"
                >
                  <FaPhone />
                  <span>Call Now</span>
                  <FaArrowRight className="rk-location-btn-arrow" />
                </a>

                <a
                  href={`https://wa.me/${WHATSAPP}?text=Hi%2C%20I%20need%20sofa%20repair%20service`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rk-location-whatsapp"
                >
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </div>

          {/* =========================
              RIGHT MAP
          ========================== */}
          <div className="rk-location-map">
            {/* Map Label */}
            <div className="rk-map-label">
              <div>
                <span>LOCATION</span>
                <strong>Sector 102, Noida</strong>
              </div>

              <div className="rk-map-label-icon">
                <FaMapMarkerAlt />
              </div>
            </div>

            {/* Map */}
            <div className="rk-map-frame">
              <iframe
                title="RK Sofa Works Location"
                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d1817276.3160681103!2d77.98001289999999!3d27.1761745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x390ce9911efe1eff%3A0xcb081a4fa866f605!2sRK%20SOFA%20WORKS%2C%20pillar%20104%2C%20near%20bhangel%2C%20Bhangel%2C%20Sector%20102%2C%20Salarpur%20Khadar%2C%20Salarpur%2C%20Noida%2C%20Uttar%20Pradesh%20201304!3m2!1d28.5436506!2d77.3861857!5e0!3m2!1sen!2sin!4v1790425643259!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Map Bottom Badge */}
            <div className="rk-map-bottom">
              <FaMapMarkerAlt />

              <div>
                <strong>RK Sofa Works</strong>
                <span>Professional Furniture Services</span>
              </div>
            </div>
          </div>
        </div>

        {/* =========================
            BOTTOM SERVICE STRIP
        ========================== */}
        <div className="rk-location-strip">
          <div className="rk-location-strip-item">
            <span>01</span>
            <div>
              <strong>Sofa Repair</strong>
              <small>Professional restoration</small>
            </div>
          </div>

          <div className="rk-location-strip-line"></div>

          <div className="rk-location-strip-item">
            <span>02</span>
            <div>
              <strong>Fabric Change</strong>
              <small>Fresh upholstery finish</small>
            </div>
          </div>

          <div className="rk-location-strip-line"></div>

          <div className="rk-location-strip-item">
            <span>03</span>
            <div>
              <strong>Furniture Care</strong>
              <small>Complete solutions</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;